import { gql } from '@apollo/client';
import { FUNDER } from '../fragments';

export const UPSERT_FUNDER = gql`
  mutation upsertFunder($input: UpsertFunderInput!) {
    funder: upsertFunder(input: $input) {
      ...funder
    }
  }
  ${FUNDER}
`;
